//@flow
import React from 'react';
import {IconButton, makeStyles, Typography} from '@material-ui/core';
import {CloseOutlined} from '@material-ui/icons';
import {colors} from '../../../../../../../assets/styles/colors';

type Props = {
  title: string,
  children: React$Node,
  canRemove?: boolean,
  onRemove?: () => void,
};

const useStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    borderRadius: '12px',
    background: '#fff',
    border: `1px solid ${colors.grey300}`,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  title: {
    fontSize: '.875rem',
    fontWeight: 600,
    color: colors.grey900,
  },
}));

export default function FilterCard({
  title,
  children,
  canRemove = false,
  onRemove,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <Typography className={classes.title}>{title}</Typography>
        {canRemove && onRemove && (
          <IconButton
            size="small"
            type="button"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              onRemove();
            }}
            aria-label="Eliminar filtro"
          >
            <CloseOutlined fontSize="small" />
          </IconButton>
        )}
      </div>
      {children}
    </div>
  );
}
